import { request } from "../../../Services/Api"

export const getIntegrationsRequests = (params) =>
  request.api.get(`/admin_panel/new_integration/`, params)
export const deleteIntegrationRequests = (id) =>
  request.api.delete(`/admin_panel/new_integration/${id}/`)
export const getRequestsIntegrationsExport = ({ file_name, ...params }) =>
  request.api.get(`/admin_panel/new_integration/export_new_integrations_data/`, params)
